import axios from "axios";
// const local_url = "http://localhost:30022/api";
const local_url = "https://wallet.obvion.io/api";


const remote_url = local_url;
// Base configuration for all API requests
export const apiClient = axios.create({
  baseURL: remote_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor for adding the token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Request OTP endpoint
export const createAccount = async (email, password, role, firstName, lastName) => {
  try {
    const payload = { email, password, role, firstName, lastName };
    const response = await apiClient.post("/elearn/auth/create-account", payload);
    return response.data;
  } catch (error) {
    console.error("Signup API error:", error.response?.data || error.message);
    throw error;
  }
};

// Login endpoint
export const loginUser = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/elearn/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

// Login endpoint
export const forgotPassword = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/elearn/auth/request-password-reset", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const payload = { token, newPassword };
    const response = await apiClient.post("/elearn/auth/reset-password", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const createCourse = async (formData) => {
  try {
    const response = await apiClient.post("/elearn/courses", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
    return response.data;
  } catch (error) {
    console.log("Course not created", error.response?.data || error.message);
    throw error;
  }
};

export const updateCourseApi = async (id, formData) => {
  try {
    const response = await apiClient.put(`/elearn/courses/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
    return response.data;
  } catch (error) {
    console.log("data not fetched", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAllCourses = async () => {
  try {
    const response = await apiClient.get("/elearn/courses");
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch all courses:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updatePublish = async (courseId) => {
  try {
    const response = await apiClient.put(`/elearn/${courseId}/publish`);
    return response.data;
  } catch (error) {
    console.log("Failed to update publish status", error.response?.data || error.message);
    throw error;
  }
};

export const deleteCourse = async (courseId) => {
  try {
    const response = await apiClient.delete(`/elearn/courses/${courseId}`);
    return response.data;
  } catch (error) {
    console.log("Failed to delete course", error.response?.data || error.message);
    throw error;
  }
};

export const getCourseById = async (courseId) => {
  try {
    const response = await apiClient.get(`/elearn/courses/${courseId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch course:", error.response?.data || error.message);
    throw error;
  }
};

// Add Lesson with support for slide images
export const addLectureApi = async (courseId, sectionId, lessonData, slideFiles = {}) => {
  try {
    const formData = new FormData();

    // Basic lesson fields
    formData.append('title', lessonData.title);
    formData.append('type', lessonData.type);
    formData.append('duration', lessonData.duration || '');
    formData.append('isPreview', lessonData.isPreview || false);

    // Type-specific fields
    if (lessonData.type === 'video' && lessonData.videoUrl) {
      formData.append('videoUrl', lessonData.videoUrl);
    }

    if (lessonData.type === 'text' && lessonData.textContent) {
      formData.append('textContent', lessonData.textContent);
    }

    // Handle slides + their images
    // if (lessonData.type === 'slides' && lessonData.slides?.length > 0) {
    //   lessonData.slides.forEach((slide, index) => {
    //     const file = slideFiles[slide.id];
        
    //     if (file) {
    //       formData.append('slides', file);
    //     }
        
    //     // Send metadata
    //     formData.append(`slideCaptions[${index}]`, slide.caption || '');
    //     formData.append(`slideOrders[${index}]`, index);
    //   });
    // }

    // Append slide images
  if (lessonData.type === 'slides') {
    Object.values(slideFiles).forEach(file => {
      if (file instanceof File) {
        formData.append('slides', file);
      }
    });
  }

    const response = await apiClient.post(
      `/elearn/courses/${courseId}/sections/${sectionId}/lectures`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Add Lecture API Error:", error.response?.data || error.message);
    throw error;
  }
};

// Update Lesson Quiz
export const updateLessonQuizApi = async (courseId, sectionId, lectureId, quizData) => {
  try {
    const response = await apiClient.put(
      `/elearn/courses/${courseId}/sections/${sectionId}/lectures/${lectureId}/quiz`,
      quizData
    );
    return response.data;
  } catch (error) {
    console.error("Update Lesson Quiz Error:", error.response?.data || error.message);
    throw error;
  }
};

// Update Final Course Quiz
export const updateFinalCourseQuizApi = async (courseId, quizData) => {
  try {
    const response = await apiClient.put(
      `/elearn/courses/${courseId}/final-quiz`,
      quizData
    );
    return response.data;
  } catch (error) {
    console.error("Update Final Quiz Error:", error.response?.data || error.message);
    throw error;
  }
};

// Create a new section
export const createSectionApi = async (courseId, title) => {
  try {
    const response = await apiClient.post(`/elearn/courses/${courseId}/sections`, {
      title: title.trim()
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create section:", error.response?.data || error.message);
    throw error;
  }
};

// Enroll in a course
export const enrollCourseApi = async (courseId) => {
  try {
    const response = await apiClient.post(`/elearn/courses/${courseId}/enroll`);
    return response.data;
  } catch (error) {
    console.error("Enroll error:", error.response?.data || error.message);
    throw error;
  }
};

export const completeLectureApi = async (courseId, lectureId) => {
  try {
    const response = await apiClient.post(`/elearn/courses/${courseId}/lectures/${lectureId}/complete`);
    return response.data;
} catch (error) {
    console.error("Complete lecture error:", error.response?.data || error.message);
    throw error;
  }
};

export const submitLessonQuizApi = async (courseId, lectureId, data) => {
  try {
    const response = await apiClient.post(`/elearn/courses/${courseId}/lectures/${lectureId}/quiz`, data);
    return response.data;
} catch (error) {
    console.error("Submit lesson quiz error:", error.response?.data || error.message);
    throw error;
  }
};

export const getProgress = async (courseId) => {
  try {
    const response = await apiClient.get(`/elearn/courses/enrollments/${courseId}/progress`);
    return response.data;
  } catch (error) {
    console.error("Failed to course progress:", error.response?.data || error.message);
    throw error;
  }
};

export const submitFinalQuizApi = async (courseId, data) => {
  try {
    const response = await apiClient.post(`/elearn/courses/${courseId}/final-quiz`, data);
    return response.data;
} catch (error) {
    console.error("Submit final quiz error:", error.response?.data || error.message);
    throw error;
  }
};

export const getMyEnrollmentsApi = async () => {
  try {
    const response = await apiClient.get('/elearn/courses/enrollments/me');
    return response.data;
  } catch (error) {
    console.error("Failed to fetch my enrollments:", error.response?.data || error.message);
    throw error;
  }
};